export default __webpack_public_path__ + "static/media/banner-1.d68f98dc.jpg";